import { render } from "./AboutProject.vue?vue&type=template&id=24cf1cc5&scoped=true"
import script from "./AboutProject.vue?vue&type=script&lang=js"
export * from "./AboutProject.vue?vue&type=script&lang=js"

import "./AboutProject.vue?vue&type=style&index=0&id=24cf1cc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24cf1cc5"]])

export default __exports__